import leftPad from './leftPad';

export default function (input) {
  const tempDate = new Date(input);
  return `${leftPad(tempDate.getMonth()+1, 0, 2)}/${leftPad(tempDate.getDate(), 0, 2)}/${tempDate.getFullYear().toString().slice(2)}`;
}

export function fullDate(input) {
  const tempDate = new Date(input);
  return `${leftPad(tempDate.getMonth()+1, 0, 2)} / ${leftPad(tempDate.getDate(), 0, 2)} / <span class="year">${tempDate.getFullYear().toString()}</span>`;
}

export function monthYear(input) {
  const tempDate = new Date(input);
  return `${leftPad(tempDate.getMonth()+1, 0, 2)}/${tempDate.getFullYear().toString()}`;
}

export function resumeDate(input) {
  const tempDate = new Date(input);
  return tempDate.toLocaleDateString('en-us', {month: 'long', year: 'numeric'});
}

export function toYear(input) {
  const tempDate = new Date(input);
  return tempDate.getFullYear().toString();
}



// WEBPACK FOOTER //
// ./shared/lib/prettyDate.js